import script from "./SubAdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubAdminPage.vue?vue&type=script&setup=true&lang=js"

import "./SubAdminPage.vue?vue&type=style&index=0&id=44086e40&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44086e40"]])

export default __exports__